// CTV-780: the info hovers' copy, its own module so FeeInfoHover.tsx exports
// only a component (react-refresh). CTV-786 cut each fee hover to its base
// calculation and nothing else, dropped the Rev share hover, and gave eCPM a
// hover about the one thing on it that needs explaining: the bonus.

import { cpmLabel } from './payoutLedgerMath';

/**
 * The hovers' copy. Variant: an organization with its own Waymark
 * agreement sees why the column is $0. Rates are the organization's own
 * passthrough terms, in dollars per 1,000 impressions.
 */
export const feeHoverCopy = {
  /**
   * The base calculation, like the fee hovers. "Upfront" is doing the work
   * the retired bonus-source row note used to: it names where the "N% bonus"
   * subtext comes from, inside the formula rather than beside it.
   */
  ecpm: 'Budget ÷ (invoiced + upfront bonus) × 1,000',
  waymark: (rateDollars: number, ownWaymark: boolean): string =>
    ownWaymark
      ? 'Waymark impressions, billed to you directly under your own Waymark agreement: $0 here.'
      : `Waymark impressions × ${cpmLabel(rateDollars)} per 1,000`,
  adServing: (rateDollars: number): string => `Delivered impressions × ${cpmLabel(rateDollars)} per 1,000`,
  stripe: '2.9% + $0.30 per advertiser charge',
};
